import { feature as topoToGeo } from "topojson-client";

const convertTopoIfNeeded = (topologyObjectsName) => (json) => {
  return topologyObjectsName
    ? topoToGeo(json, json.objects[topologyObjectsName])
    : json;
};
const toJSON = (response) => response.json();
const fetchJson = (url) => fetch(url).then(toJSON);

export const getGeoJSON = (url, topologyObjectsName) => {
  return (dispatch) => {
    dispatch({ type: "GEOJSON:REQUEST" });
    return fetchJson(url)
      .then(convertTopoIfNeeded(topologyObjectsName))
      .then((geojson) =>
        dispatch({ type: "GEOJSON:SUCCESS", payload: geojson })
      )
      .catch((error) => dispatch({ type: "GEOJSON:FAILURE", payload: error }));
  };
};

const getSheetId = () => {
  const staging = process.env.REACT_APP_STAGING === "true";

  return staging
    ? "1fT9HkSzPrf6-NBVV88ZaqkZNhNncKq-GXP7rwWLA9Bc" // Staging
    : "1fT9HkSzPrf6-NBVV88ZaqkZNhNncKq-GXP7rwWLA9Bc"; // Prod TO
};

export const getAllProjects = () => {
  return (dispatch) => {
    const sheetId = getSheetId();

    dispatch({ type: "PROJECT:ALL:REQUEST" });

    return fetchJson(
      `https://holy-sheet.visualise.today/sheet/${sheetId}?range='Fund Names'`
    )
      .then((json) => {
        const promises = json.map(({ Fund }) =>
          fetchJson(
            `https://holy-sheet.visualise.today/sheet/${sheetId}?range='${encodeURIComponent(
              Fund
            )}'!A1:Q10000`
          ).then((data) => ({
            fundName: Fund,
            data,
          }))
        );
        return Promise.all(promises);
      })
      .then((dataForAllFund) => {
        dispatch({
          type: "PROJECT:ALL:SUCCESS",
          payload: dataForAllFund,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: "PROJECT:ALL:ERROR", payload: err });
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/data.js